import React, { PureComponent } from "react";
import Footer from "../../../../containers/Footer";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";

import BackIcon from "../../../../assets/svg/BackIcon";
import { useNavigate } from "react-router-dom";
import Header from "../../../../containers/Header";
import BeforeLoginFooter from "../../../../containers/BeforeLoginFooter";

const BeforeAffiliate = () => {
  const navigate = useNavigate();
  return (
    <div>
      <Header />

      <main className="main static-page">
        <div className="container">
          <div className="headingSec">
            <h4>Coming Soon</h4>
            {/* <div className="back-link" onClick={() => navigate(-1)}>
              <BackIcon /> Back
            </div> */}
          </div>
        </div>
      </main>

      <BeforeLoginFooter />
    </div>
  );
};

export default BeforeAffiliate;
